module.exports = __webpack_public_path__ + "img/file-dropzone-drop.b27c70dd.svg";